/**
 * Upgrades records written by older schema versions to the current shape. Used by the Dexie
 * version upgrade, backup restore and sync-package import, so old files stay readable.
 *
 *   schema 1 → 2: expenses gain `duplicate` (no review recorded → status "none").
 */
import { emptyDuplicateReview, type Expense } from "./model";

export function upgradeExpenseRecord(record: Expense | Omit<Expense, "duplicate">): Expense {
  return "duplicate" in record && record.duplicate ? record : { ...record, duplicate: emptyDuplicateReview() };
}
